// removed by extract-text-webpack-plugin
module.exports = {"colorPrimaryOrange":"#e16e46","colorSecondaryRagAmber":"#ffbf00","railStyle":"rc-slider__railStyle____3_uW3"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/widgets/slider/rc-slider.css
// module id = 527
// module chunks = 0